export default __webpack_public_path__ + "static/media/background.878958b2.png";